// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Plans_pageWrapper__+x24R","page":"Plans_page__NlQbV","plansGrid":"Plans_plansGrid__nr6pl","footnote":"Plans_footnote__u8OYG"};